import AWS from 'aws-sdk';

const spacesEndpoint = new AWS.Endpoint(process.env.REACT_APP_DO_SPACES_ENDPOINT);

const s3 = new AWS.S3({
  endpoint: spacesEndpoint,
  accessKeyId: process.env.REACT_APP_DO_SPACES_KEY,
  secretAccessKey: process.env.REACT_APP_DO_SPACES_SECRET,
  httpOptions: {
    timeout: 300000,       // ⏱️ 5 minutes total timeout
    connectTimeout: 10000, // ⏱️ 10 seconds to connect
  },
  maxRetries: 3,
});

export const uploadToSpaces = async (file, folder = 'uploads') => {
  const filename = `${folder}/${Date.now()}-${file.name}`;

  const params = {
    Bucket: process.env.REACT_APP_DO_SPACES_BUCKET,
    Key: filename,
    Body: file,
    ACL: 'public-read',
    ContentType: file.type,
  };

  try {
    console.log(`🚀 Uploading: ${file.name} (${(file.size / 1024 / 1024).toFixed(2)} MB) | Type: ${file.type}`);

    const data = await s3.upload(params).promise();


    console.log('✅ Upload complete:', data.Location);

return data.Location.startsWith('http') ? data.Location : `https://${data.Location}`;

  } catch (err) {
    console.error('❌ Upload failed:', err.message);
    throw err;
  }
};
